import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import moment from 'moment';
import AttendanceReportModal from './attendanceModal';
import "./_tableReportData.scss";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';

class ReportTableData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attendanceReportModal: false,
            startDateInput: moment.unix(this.props.stateData.startDateCalender).format("YYYY-MM-DD"),
            endDateInput: moment.unix(this.props.stateData.endDateCalender).format("YYYY-MM-DD"),
            dateArrayfinal: [],
            loader: 0,
            mainTableStartDate: moment.unix(this.props.stateData.startDateCalender).format("DD-MM-YYYY"),
            mainTableEndDate: moment.unix(this.props.stateData.endDateCalender).format("DD-MM-YYYY"),
            roomWiseData: [],
        };
    }

    componentDidMount() {
        var dateArray = [];
        var currentDate = moment(this.state.startDateInput);
        var stopDate = moment(this.state.endDateInput);
        while (currentDate <= stopDate) {
            dateArray.push({ date: moment(currentDate).format('DD-MM-YYYY'), unixDate: moment(currentDate, 'MM-DD-YYYY').unix() })
            currentDate = moment(currentDate).add(1, 'days');
        }
        this.setState({ dateArrayfinal: dateArray })
    }

    articlecolumns = [
        {
            dataField: "date",
            text: "FromDate    to    ToDate",
            // sort: true,
        },
        {
            dataField: "buildFloorRoomDetails",
            text: "Building/Floor/Room",
            sort: true,
        },
        {
            dataField: "no_of_students",
            text: "No of Students",
            sort: true,
        },
        {
            dataField: "Details",
            text: "Details",
            formatter: this.performanceFunc.bind(this),
        },
    ];

    performanceFunc(val, row) {
        console.log("rowwwwwwwwwww", row)
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ attendanceReportModal: true, roomWiseData: row.attendanceData })}>
                <Button variant="link" name="edit" className="text-theme">
                    <i className="fas fa-eye" />
                </Button>
            </div>
        </>)
    }

    render() {

        console.log("state122", this.state);

        const propsData = this.props;

        const overAllDetails = this.props.stateData.getBuildingFloorAndRoomDetails;

        const FilterBuildings = overAllDetails.filter((item) => item.hostel_building_id == propsData.stateData.buildingSearch);

        console.log("FilterBuildings", FilterBuildings);

        let tableData = [];
        propsData.stateData.roomSelectedvalue.map((item) => {
            console.log("items", item);

            FilterBuildings[0].floors_details.map((item2) => {
                console.log("item2", item2);
                item2.rooms_details.map((item3) => {
                    if (item.value == item3.room_id) {
                        let presentCount = item3.capacity_details.filter((item4) => item4.attendance_status == 1 && item4.attended_date != null).length
                        let absentCount = item3.capacity_details.filter((item4) => item4.attendance_status == 0 && item4.attended_date != null).length

                        const uniqueStudents = item3.capacity_details.filter(
                            (currentObj, currentIndex, self) =>
                                self.findIndex((obj) => obj.edu_student_id === currentObj.edu_student_id) === currentIndex
                        );

                        let buildFloorRoomDetails = `${propsData.stateData.buildingName}/${item2.floor_name}/${item3.room_name}`
                        tableData.push({ date: `${this.state.mainTableStartDate + " to " + this.state.mainTableEndDate}`, buildFloorRoomDetails: buildFloorRoomDetails, no_of_students: uniqueStudents.length, presentCount: presentCount, absentCount: absentCount, attendanceData: item3.capacity_details })
                    }
                })
            })
        });
        console.log("tableData", tableData);
        return (
            <section>
                <div className="">
                    <Container>
                        {
                            tableData.length > 0 ? (
                                <CardLessDataTable
                                    parentData={tableData}
                                    particlecolumns={this.articlecolumns}
                                    name="hostel_attendance"
                                    SearchBar={true}
                                />
                            )
                                :
                                (
                                    <Row>
                                        <div style={{ backgroundColor: "red" }}>
                                            <h4 className='mt-3 text-center'><span className="text-danger"> * </span>  No data available</h4>
                                        </div>
                                    </Row>
                                )
                        }
                    </Container>
                    <AttendanceReportModal
                        show={this.state.attendanceReportModal}
                        onHide={() => this.setState({ attendanceReportModal: false, loader: 0 })}
                        stateData={this.state}
                        globals={this.props.globals}
                        getNewEducationalStudents={this.props.getNewEducationalStudents}
                    />
                </div>
            </section>
        );
    }
}
export default ReportTableData;